import { NgModule } from '@angular/core';
import { AuthService } from './auth.service';
import { AuthJWTService } from './jwt/auth-jwt.service';

import { AuthGuardLoggedIn } from './auth-guard-logged-in.service';
import { AuthGuardUser } from './auth-guard-user.service';
import { AuthGuardManager } from './auth-guard-manager.service';
import { AuthGuardAdmin } from './auth-guard-admin.service';
import { AuthGuardSuperAdmin } from './auth-guard-superadmin.service';
import { AuthGuardClient } from './auth-guard-client.service';
import { GraphService } from './graph/graph.service';
import { AuthMSALService } from './msal/auth-msal.service';
import { AuthGuardExternalUser } from './auth-guard-externalUser.service';
import { AuthGuardAuthenticated } from './auth-guard-authenticated';

// export function authHttpServiceFactory(http: Http, options: RequestOptions) {
//   return new AuthHttp(new AuthConfig(), http, options);
// }

@NgModule({
  imports: [
  ],
  providers: [
    AuthService,
    AuthJWTService,
    AuthGuardLoggedIn,
    AuthGuardAuthenticated,
    AuthGuardClient,
    AuthGuardExternalUser,
    AuthGuardUser,
    AuthGuardManager,
    AuthGuardAdmin,
    AuthGuardSuperAdmin,
    GraphService,
    AuthMSALService
  ],
  exports: [
  ],
  declarations: []
})
export class AuthModule { }



// WEBPACK FOOTER //
// ./client/app/core/auth/auth.module.ts